<template>
  <a-drawer v-model:visible="show" :closable="false" :destroyOnClose="true" :mask="false" :maskClosable="false"
            :width="600" class="custom-class" placement="right">
    <a-spin :spinning="spinning">
      <div class="detail" @click="isShowColor = false">
        <div class="det-head">
          <div class="f-20 f-c-999 close" title="关闭" @click="handleCloseDrawer">
            <close-outlined/>
          </div>
          <div class="f-20 f-c-999 refresh" title="刷新" @click="getOrderDetail(order_id)">
            <sync-outlined/>
          </div>
          <a-tabs v-model:activeKey="activeKey" :tabBar-style="tabBarStyle" @change="handleChangeTabs">
            <a-tab-pane :key="1" tab="订单详细"></a-tab-pane>
            <a-tab-pane v-if="otherOrder.length" :key="3" tab="其他订单">
            </a-tab-pane>
            <a-tab-pane v-if="showDayRemark" :key="2" tab="日期备忘">
              <div class="detail-info">
                <a-textarea v-model:value="orderDet.dayRemark" :auto-size="{ minRows: 5 }" allowClear
                            placeholder="备忘信息，如（已约保洁）"/>
                <div style="margin-top: 20px">
                  <a-button type="primary" @click="saveDateRemark">保存</a-button>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane :key="4" tab="操作日志">
              <div class="detail-info">
                <!-- 日志列表 -->
                <div class="info-cont" style="width: 100%;">
                  <a-table :columns="logColumns" :dataSource="orderLogList" :pagination="false" size="small">
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key == 'create_time'">
                        <div class="f-12">操作人：{{ record.staff_id > 0 ? record.staffName : '创建者' }}</div>
                        <div class="f-12">{{ record.create_time }}</div>
                      </template>
                      <template v-if="column.key == 'content'">
                        <span class="f-12">{{ record.typeName }},{{ record.content }}</span>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
          <!-- 订单详情/其他订单 -->
          <div v-show="activeKey == 1 || activeKey == 3" class="detail-info">
            <!-- 订单切换 -->
            <div v-if="otherOrder.length" class="order-tab">
              <div v-for="item in otherOrder" :key="item.id" :class="{ selOrder: order_id == item.id }"
                   class="order-box"
                   @click="selOrder(item)">
                <div class="order-source">
                  <img :src="item.source_logo" style="width: 30px"/>
                </div>
                <div class="order-info">
                  <div class="line-1" style="max-width: 200px">
                    <text v-if="item.tname">{{ item.tname }},{{ item.tphone }}</text>
                    <text v-else>{{ item.order_no }}</text>
                  </div>
                  <div class="f-c-999">
                    {{ dayjs(item.start_date).format("MM.DD") }}-{{
                      dayjs(item.end_date).format("MM.DD")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="head-house">
              <div class="house-top">
                <div class="top-img">
                  <a-image :src="orderDet.image || logo" fit="fill" style="width: 70px; height: 50px"/>
                </div>
                <div class="top-text">
                  <div class="text_left">
                    <div class="text-name">
                      {{ orderDet.rname || "独立房间" }}({{ orderDet.name }})
                    </div>
                    <div class="text-type">
                      {{ orderDet.type_text }}_{{ orderDet.id }}_{{ orderDet.hid }}
                    </div>
                  </div>

                  <div v-if="(orderDet.status == 4 || orderDet.status == 3) &&
                    orderDet.order_type !== 2
                    " class="text_right" @click="handleChangeRoom">
                    换房
                  </div>
                </div>
              </div>
              <!-- <div class="house-bom">
                  <span>{{orderDet.status_explain ? orderDet.status_explain : orderDet.status_text}} </span>
                </div> -->
            </div>
            <!-- 基本信息 -->
            <div class="head-info">
              <!-- <div class="info-title">
                    <div class="title-left">基础信息</div>
                  </div> -->
              <div class="info-cont">
                <div class="cont-cell">
                  <div class="cell-title">状态</div>
                  <div class="cell-data">
                    <div :style="{
                      backgroundColor: handleStatusColor(orderDet),
                    }" class="cell-tab">
                      {{
                        orderDet.status_explain
                            ? orderDet.status_explain
                            : orderDet.status_text
                      }}
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">排房状态</div>
                  <div class="cell-data" style="display: flex; justify-content: space-between">
                    <div class="info-cont">
                      {{ orderDet.order_type == 2 ? "未排房" : "已排房" }}
                    </div>
                    <div class="link">
                      <div v-if="orderDet.order_type == 2" style="cursor: pointer" @click="handleChangeRoom">
                        排房
                      </div>
                      <div v-else style="cursor: pointer" @click="moveBoxOrder">
                        撤销排房
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">入离</div>
                  <div class="cell-data">
                    {{ orderDet.start_date }} ~ {{ orderDet.end_date }} 共{{
                      orderDet.nights
                    }}晚
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">来源</div>
                  <div class="cell-data">
                    {{ orderDet.sname }}
                    {{ orderDet.source_id != 0 ? orderDet.out_trade_no : "" }}
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">可住人数</div>
                  <div class="cell-data">{{ orderDet.capacity }}人</div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">房客</div>
                  <div class="cell-data">
                    {{ orderDet.tname }}({{ tenantList.length }}人)
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">手机</div>
                  <div v-if="editPhone" class="cell-data">
                    <a-input v-model:value="orderDet.tphone" allowClear placeholder="请输入手机号"
                             style="width: 150px"/>
                  </div>
                  <div v-else class="cell-data">{{ orderDet.tphone || "-" }}
                    <span v-if="orderDet.tphone" class="f-c-b" style="cursor: pointer" @click="sendSms">发送短信<span
                        class="f-c-999">{{ sendSmsMsg }}</span></span>
                  </div>
                  <div class="link f-c-b">
                    <div v-if="!editPhone" style="cursor: pointer" @click="editPhone = true">
                      修改
                    </div>
                    <div v-else style="display: flex; justify-content: space-between;">
                      <div>
                        <span style="cursor: pointer;" @click="handleEditPhone">保存</span>
                      </div>
                      <div style="margin-left: 10px;">
                        <span style="cursor: pointer;" @click="cencelEditPhone">取消</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="orderDet.is_pwd == 1" class="cont-cell">
                  <div class="cell-title">门锁密码</div>
                  <div v-if="editPwd" class="cell-data">
                    <a-input v-model:value="orderDet.lock_pwd" allowClear placeholder="请输入门锁密码"
                             style="width: 150px"/>
                  </div>
                  <div v-else class="cell-data">{{ orderDet.lock_pwd || "-" }}</div>
                  <div class="link f-c-b">
                    <div v-if="!editPwd" style="cursor: pointer" @click="editPwd = true">
                      设置密码
                    </div>
                    <!--                    <div-->
                    <!--                        style="cursor: pointer"-->
                    <!--                        @click="handleEditPhone"-->
                    <!--                        v-else-->
                    <!--                    >-->
                    <!--                      保存-->
                    <!--                    </div>-->
                    <div v-else style="display: flex; justify-content: space-between;">
                      <div>
                        <span style="cursor: pointer;" @click="handleEditPwd">保存</span>
                      </div>
                      <div style="margin-left: 10px;">
                        <span style="cursor: pointer;" @click="cencelEditPwd">取消</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">订单号</div>
                  <div class="cell-data">
                    {{ orderDet.order_no }}
                    <span class="copy" @click="handleCopy">复制</span>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">会员信息</div>
                  <div class="cell-data">
                    {{ orderDet.nickname }}(会员ID:{{ orderDet.user_id }})
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">颜色标记</div>
                  <div class="cell-data">
                    <a-select ref="select" v-model:value="orderDet.color" placeholder="无" style="width: 30%"
                              @change="saveOrderColor">
                      <a-select-option value="">无</a-select-option>
                      <a-select-option v-for="item in searchList.color.list" :key="item.id" :value="item.color"
                                       size="small">
                        <div style="display: flex; align-items: center">
                          <div :style="{ backgroundColor: item.color }" class="color-box"></div>
                          {{ item.name }}
                        </div>
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="cont-cell" style="align-items: center">
                  <div class="cell-title">标签</div>
                  <div class="cell-data">
                    <div class="head-tag">
                      <div v-if="orderDet.order_type == 2" class="tag-btn f-12" style="background-color: #ff4d4f">
                        盒子订单
                      </div>
                      <div v-for="(item, index) in orderDet.gname" v-show="orderDet.gname" :key="index"
                           :style="{ 'background-color': item.color }" class="tag-btn f-12">
                        {{ item.name }}
                      </div>
                      <div class="tag-btn-g f-12" @click="tagShow = true">
                        +添加标签
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">备注</div>
                  <div class="cell-data" style="display: flex; justify-content: space-between">
                    <div v-if="remarkShow">
                      <div style="width: 400px">
                        <a-textarea v-model:value="orderDet.company_remark" :auto-size="{ minRows: 2 }" :maxlength="400"
                                    allowClear placeholder="请输入备注(选填)" show-count/>
                      </div>
                    </div>
                    <div v-else class="info-cont">
                      {{ orderDet.company_remark || "-" }}
                    </div>
                    <div class="link">
                      <div v-if="!remarkShow" style="cursor: pointer" @click="remarkShow = true">
                        修改
                      </div>
                      <div v-else style="cursor: pointer" @click="handleEditRemark">
                        确定
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 房客 -->
            <div class="head-info">
              <div class="info-title">
                <div class="title-left">房客</div>
                <div class="title-right f-c-b" style="cursor: pointer" @click="handleAddTenant">
                  添加
                </div>
              </div>
              <div v-if="tenantList.length" class="info-cont">
                <a-table :columns="tenantColumns" :dataSource="tenantList" :pagination="false" size="small">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key == 'name'">
                      <div v-if="record.delete_time > 0">
                        {{
                          record.name
                        }}<span style="color: red">(已删除)</span>
                      </div>
                      <div v-else>
                        {{ record.name }}
                        <span v-if="record.is_verify == 2" style="color: red">(不通过)</span>
                        <span v-else style="color: green">(通过)</span>
                      </div>
                    </template>
                    <template v-if="column.key == 'oper'">
                      <div v-if="orderDet.status != 5 &&
                        orderDet.status != 6 &&
                        record.delete_time == 0
                        " style="display: flex">
                        <a-button class="right-edit" type="link" @click="handleEditTenant(record, 1)">
                          编辑
                        </a-button>
                        <a-button class="right-del" style="color: #da0000" type="link" @click="handleDelTenant(record)">
                          删除
                        </a-button>
                      </div>
                      <div v-else style="display: flex">
                        <a-button class="right-edit" type="link" @click="handleEditTenant(record, 2)">
                          查看
                        </a-button>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
            </div>
            <!-- 费用 -->
            <div class="head-info">
              <div class="info-title">
                <div class="title-left">费用</div>
                <div class="title-right" style="cursor: pointer" @click="accountShow = true">
                  记账
                </div>
              </div>
              <div class="info-cont">
                <div class="cont-cell">
                  <div class="cell-title">总房费</div>
                  <div class="cell-data">￥{{ orderDet.total_amount }}</div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">佣金</div>
                  <div class="cell-data">
                    <span class="f-c-green">￥{{ orderDet.royalty }}</span>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">净房费</div>
                  <div class="cell-data">￥{{ orderDet.room_price }}</div>
                </div>
                <!-- <div class="cont-cell">
                      <div class="cell-title">押金</div>
                      <div class="cell-data">￥{{ orderDeposit.amount }}</div>
                    </div> -->
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">押金</div>
                  <div class="cell-data" style="display: flex; justify-content: space-between">
                    <template v-if="!editDeposit">
                      <div class="data-check">
                        <div v-if="orderDeposit.status == 2">
                          ￥{{ orderDeposit.amount }}
                        </div>
                        <div v-else style="
                            border-bottom: 1px solid #666666;
                            cursor: pointer;
                          " title="点击修改" @click="editDeposit = true">
                          ￥{{ orderDeposit.amount }}
                        </div>
                        <div v-if="Number(orderDeposit.amount)" class="f-c-999 f-12">
                          （{{
                            orderDeposit.status == 1
                                ? orderDeposit.status_text
                                : orderDeposit.refund_status_text
                          }}）
                          <span v-if="orderDeposit.status == 2 &&
                              orderDeposit.refund_status != 2
                              ">支付时间：{{ orderDeposit.pay_time }}</span>
                          <span v-else-if="orderDeposit.status == 2 &&
                            orderDeposit.refund_time != 0
                            ">退款时间：{{ orderDeposit.refund_time }}</span>
                        </div>
                      </div>
                      <div>
                        <div v-if="orderDeposit.status == 1 &&
                          Number(orderDeposit.amount)
                          " class="link" @click="depositFree">
                          免押
                        </div>
                        <div v-if="orderDeposit.status == 1 &&
                          Number(orderDeposit.amount)
                          " class="link" @click="refreshPayStatus">
                          刷新
                        </div>
                        <div v-if="orderDeposit.status == 2 &&
                          orderDeposit.refund_status !== 2 &&
                          orderDeposit.refund_status !== 3
                          " class="link" @click="openRefund">
                          退款
                        </div>
                        <div v-if="orderDeposit.status == 2 &&
                          orderDeposit.refund_status == 2
                          " class="link" @click="openRefundAgain">
                          修改金额
                        </div>
                      </div>
                    </template>
                    <div v-else class="data-check">
                      <div class="data-val">
                        <a-input v-model:value="orderDeposit.amount" placeholder="需付押金" style="width: 100px"/>
                        <span class="f-c-b" style="cursor: pointer" @click="
                          editDepositSave({
                            amount: orderDeposit.amount,
                          })
                          ">保存</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">优惠金额</div>
                  <div class="cell-data">
                    <span class="f-c-green">￥{{ orderDet.discount }}</span>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">实付金额</div>
                  <div class="cell-data">
                    <span class="f-c-red">￥{{ orderDet.pay_amount }}</span>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">订单总额</div>
                  <div class="cell-data">
                    <span class="f-c-red">￥{{ orderDet.order_amount }}</span>
                  </div>
                </div>
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">其他费用</div>
                  <div class="cell-data">
                    <span class="f-c-b" style="cursor: pointer" @click="showCostList = !showCostList">查看</span>
                  </div>
                </div>
                <!-- 其他费用 -->
                <div v-if="showCostList" class="info-cont" style="width: 100%; margin-bottom: 10px">
                  <a-table :columns="costColumns" :dataSource="costList" :pagination="false" size="small">
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key == 'income'">
                        <span v-if="record.type == 1" style="color: #dd0054">+{{ record.price }}</span>
                        <span v-else style="color: #1aa034">-{{ record.price }}</span>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
            <!-- 入住管理 -->
            <div class="head-info">
              <div class="info-title">
                <div class="title-left">入住管理</div>
                <div class="title-right f-c-b" style="cursor: pointer" @click="checkInGuide">
                  分享入住
                </div>
              </div>
              <div class="info-cont">
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">到店日期</div>
                  <div class="cell-data">{{ orderDet.start_date }}</div>
                </div>
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">离店日期</div>
                  <div class="cell-data">{{ orderDet.end_date }}</div>
                </div>
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">可入住时间</div>
                  <div v-if="tenantDet.in_time" class="cell-data">
                    {{ tenantDet.in_time }}
                    <a-time-picker v-model:value="editInTime" :allowClear="false" :showNow="false" format="HH:mm"
                                   size="small" @change="editTime(1)"/>
                  </div>
                </div>
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">退房时间</div>
                  <div v-if="tenantDet.out_time" class="cell-data">
                    {{ tenantDet.out_time }}
                    <a-time-picker v-model:value="editOutTime" :allowClear="false" :showNow="false" format="HH:mm"
                                   size="small" @change="editTime(2)"/>
                  </div>
                </div>
                <div class="cont-cell" style="height: 30px">
                  <div class="cell-title">开门记录</div>
                  <div class="cell-data">
                    <span class="f-c-b" style="cursor: pointer" @click="handleOpenList()">查看</span>
                  </div>
                </div>
                <!-- 开门记录 -->
                <div v-if="showOpenList" class="info-cont" style="width: 100%; margin-bottom: 10px">
                  <a-table :columns="columns" :dataSource="openList" :loading="searchLoading" :pagination="false"
                           class="table"
                           size="small">
                  </a-table>
                  <a-pagination v-if="openListTotal > 10" :total="openListTotal" size="small" style="margin-top: 5px"
                                @change="pageChange" @showSizeChange="onShowSizeChange"/>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">身份验证</div>
                  <div class="cell-data">
                    <div class="data-check">
                      <div class="data-val">
                        <a-select ref="select" v-model:value="orderDet.check_identity" style="width: 100%" @change="
                          checkConfirm({
                            check_identity: orderDet.check_identity,
                          })
                          ">
                          <a-select-option v-for="item in searchList.checkIdentity.list" :key="item.id"
                                           :value="item.id">{{ item.name }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="cont-cell">
                      <div class="cell-title">防疫资料</div>
                      <div class="cell-data">
                        <div class="data-check">
                          <div class="data-val">
                            <a-select
                              ref="select"
                              v-model:value="orderDet.epidemic_info"
                              style="width: 100%"
                              @change="
                                checkConfirm({
                                  epidemic_info: orderDet.epidemic_info,
                                })
                              "
                            >
                              <a-select-option
                                v-for="item in searchList.epidemicInfo.list"
                                :key="item.id"
                                :value="item.id"
                                >{{ item.name }}</a-select-option
                              >
                            </a-select>
                          </div>
                        </div>
                      </div>
                    </div> -->
                <div class="cont-cell">
                  <div class="cell-title">登记人数</div>
                  <div class="cell-data">
                    <div class="data-check">
                      <div class="data-val">
                        <a-select ref="select" v-model:value="orderDet.capacity" style="width: 100%" @change="
                          checkConfirm({ capacity: orderDet.capacity })
                          ">
                          <a-select-option v-for="item in searchList.register.list" :key="item" :value="item">最少登记{{
                              item
                            }}人
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">证件要求</div>
                  <div class="cell-data">
                    <div class="data-check">
                      <div class="data-val">
                        <a-select ref="select" v-model:value="orderDet.certificate_requirements" style="width: 100%"
                                  @change="
                            checkConfirm({
                              certificate_requirements:
                                orderDet.certificate_requirements,
                            })
                            ">
                          <a-select-option v-for="item in searchList.certificateRequirements
                            .list" :key="item.id" :value="item.id">{{ item.name }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">核验模式</div>
                  <div class="cell-data">
                    <div class="data-check">
                      <div class="data-val">
                        <a-select ref="select" v-model:value="orderDet.verify_mode" style="width: 100%" @change="
                          checkConfirm({
                            verify_mode:
                              orderDet.verify_mode,
                          })
                          ">
                          <a-select-option v-for="item in searchList.verifyMode
                            .list" :key="item.id" :value="item.id">{{ item.name }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cont-cell">
                  <div class="cell-title">开放功能</div>
                  <div class="cell-data">
                    <div class="data-check">
                      <div class="data-val">
                        <a-select ref="select" v-model:value="orderDet.open_fun" :showSearch="false" mode="multiple"
                                  placeholder="请选择" style="width: 100%" @change="
                            checkConfirm({
                              open_fun: orderDet.open_fun.toString(),
                            })
                            ">
                          <a-select-option v-for="item in orderDet.openFun || []" :key="item.id" :value="item.id">{{
                              item.name
                            }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 其他 -->
            <div class="head-info">
              <div class="info-title">
                <div class="title-left">其他</div>
              </div>
              <div class="info-cont">
                <!-- <div class="cont-cell">
                    <div class="cell-title">订单号</div>
                    <div class="cell-data">{{ orderDet.order_no }}</div>
                  </div> -->
                <div class="cont-cell">
                  <div class="cell-title">下单时间</div>
                  <div class="cell-data">{{ orderDet.create_time }}</div>
                </div>
                <div v-if="orderDet.pay_time" class="cont-cell">
                  <div class="cell-title">支付时间</div>
                  <div class="cell-data">{{ orderDet.pay_time }}</div>
                </div>
                <div v-if="orderDet.receive_time" class="cont-cell">
                  <div class="cell-title">确认时间</div>
                  <div class="cell-data">{{ orderDet.receive_time }}</div>
                </div>
                <div v-if="orderDet.checkin_time" class="cont-cell">
                  <div class="cell-title">入住时间</div>
                  <div class="cell-data">{{ orderDet.checkin_time }}</div>
                </div>
                <div v-if="orderDet.checkout_time" class="cont-cell">
                  <div class="cell-title">退房时间</div>
                  <div class="cell-data">{{ orderDet.checkout_time }}</div>
                </div>
                <div v-if="orderDet.cancel_time" class="cont-cell">
                  <div class="cell-title">取消时间</div>
                  <div class="cell-data">{{ orderDet.cancel_time }}</div>
                </div>
                <div v-if="orderDet.refund_time" class="cont-cell">
                  <div class="cell-title">申请退款时间</div>
                  <div class="cell-data">{{ orderDet.refund_time }}</div>
                </div>
                <div v-if="orderDet.finish_time" class="cont-cell">
                  <div class="cell-title">完成时间</div>
                  <div class="cell-data">{{ orderDet.finish_time }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 70px"></div>
        <!-- 操作栏 -->
        <div v-if="activeKey == 1 || activeKey == 3" class="operate">
          <div class="operate-lef">
            <a-button v-show="activeKey == 2" class="btn-primary" style="margin-right: 8px"
                      @click="accountShow = true">记账
            </a-button>
            <a-button v-if="orderDet.status == 2" class="btn-primary" style="margin-right: 8px"
                      @click="handleOper(3)">确认订单
            </a-button>
            <a-button v-if="orderDet.status == 3" class="btn-primary" style="margin-right: 8px"
                      @click="handleOper(1)">入住
            </a-button>
            <a-button style="margin-right: 8px" @click="checkInGuide">分享入住</a-button>
            <a-button v-if="orderDet.status == 3 || orderDet.status == 4" style="margin-right: 8px"
                      @click="openStayover">续住
            </a-button>
          </div>
          <div class="operate-rig">
            <a-button danger style="margin-right: 8px" type="primary" @click="
              showEditOrder = true;
            show = false;
            ">修改订单
            </a-button>
            <a-button v-if="orderDet.status == 4" style="margin-right: 8px" @click="handleOper(5)">撤销入住</a-button>
            <a-button v-if="orderDet.status == 2 || orderDet.status == 3" style="margin-right: 8px"
                      @click="handleOper(2)">取消订单
            </a-button>
            <a-button v-if="orderDet.status == 4" style="margin-right: 8px" @click="handleOper(4)">退房</a-button>
          </div>
        </div>
      </div>
    </a-spin>
  </a-drawer>

  <!-- 添加标签 -->
  <a-modal v-model:visible="tagShow" title="添加标签" @ok="handleAddTags">
    <a-checkbox-group v-model:value="selTag">
      <div class="addTags">
        <div v-for="item in searchList.tag?.list" :key="item.id" :style="{ 'background-color': item.bgcolor }"
             class="tag-cell">
          <a-checkbox :value="item.id">
            <span style="color: #ffffff">{{ item.name }}</span>
          </a-checkbox>
        </div>
      </div>
    </a-checkbox-group>
  </a-modal>
  <!-- 记账 -->
  <a-modal v-model:visible="accountShow" title="记账" width="700px" @ok="handleAddAccount">
    <div class="addAccount">
      <a-form ref="accountRef" :label-col="{ span: 7 }" :model="accountForm"
              :rules="[{ required: true, message: '请选择类型' }]" labelAlign="left">
        <a-row justify="space-between" type="flex">
          <a-col :span="12">
            <a-form-item label="类型">
              <a-radio-group v-model:value="accountForm.type">
                <a-radio value="1">收入</a-radio>
                <a-radio value="2">支出</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item :rules="[{ required: true, message: '请选择类型' }]" label="项目" name="project">
              <a-select v-model:value="accountForm.project" placeholder="请选择项目" style="width: 100%">
                <a-select-option v-for="item in accountForm.type == 1
                  ? searchList.income?.list
                  : searchList.inout?.list" v-show="accountForm.type == 1" :key="item.id" :value="item.id">{{
                    item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :rules="[{ required: true, message: '请输入金额' }]" label="金额" name="price">
              <a-input v-model:value="accountForm.price" :placeholder="accountForm.type == 1 ? '请输入收入金额' : '请输入支出金额'
                " style="width: 100%"/>
            </a-form-item>
            <a-form-item :rules="[{ required: true, message: '请选择交易方式' }]" label="交易方式" name="mode">
              <a-select v-model:value="accountForm.mode" placeholder="请选择交易方式" style="width: 100%">
                <a-select-option v-for="item in searchList.paytype?.list" :key="item.id" :value="item.id">{{
                    item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :rules="[{ required: true, message: '请选择时间' }]" label="时间" name="date">
              <a-date-picker placeholder="时间" show-time style="width: 100%" @change="accountDateOk"/>
            </a-form-item>
          </a-col>
          <a-col :span="11">
            <a-form-item label="凭证" name="imageUrl">
              <a-upload v-model:file-list="accountForm.image" :action="action" :before-upload="beforeUpload"
                        :data="upLoadData" :headers="upLoadHeader" :show-upload-list="false"
                        class="avatar-uploader" list-type="picture-card" name="image"
                        @change="upLoadChange($event, 'imageUrl')">
                <img v-if="accountForm.imageUrl" :src="accountForm.imageUrl" alt="avatar" height="102" width="102"/>
                <div v-else>
                  <loading-outlined v-if="uploadLoading"></loading-outlined>
                  <plus-outlined v-else></plus-outlined>
                  <div class="ant-upload-text">上传凭证</div>
                </div>
              </a-upload>
            </a-form-item>
            <a-form-item label="备注">
              <a-textarea v-model:value="accountForm.remark" :auto-size="{ minRows: 4 }" :maxlength="200" allowClear
                          placeholder="请输入备注(选填)" show-count/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-modal>
  <!-- 房客添加编辑 -->
  <a-modal v-model:visible="tenantShow" :footer="addTenantTitle == '查看房客' ? null : undefined"
           :title="addTenantTitle"
           width="1000px">
    <a-form ref="tenantRef" :label-col="{ span: 6 }" :model="tenantForm" :wrapper-col="{ span: 15 }" autocomplete="off">
      <a-row justify="space-between" type="flex">
        <a-col :span="11">
          <a-form-item extra="仅通过审核,房客才可查看密码和开门" label="审核状态" name="is_verify">
            <a-radio-group v-model:value="tenantForm.is_verify" button-style="solid">
              <a-radio-button :value="1">通过</a-radio-button>
              <a-radio-button :value="2">不通过</a-radio-button>
            </a-radio-group>
            <div v-if="tenantForm.is_verify == 2" style="padding: 5px 0px;color: red;">{{ tenantForm.is_verify_msg }}
            </div>
          </a-form-item>
          <a-form-item label="姓名" name="name">
            <a-input v-model:value="tenantForm.name" placeholder="上传身份证自动获取"/>
          </a-form-item>
          <a-form-item label="证件类型" name="type">
            <a-select ref="select" v-model:value="tenantForm.type">
              <a-select-option :value="1">身份证</a-select-option>
              <a-select-option :value="2">大陆护照</a-select-option>
              <a-select-option :value="3">大陆驾驶证</a-select-option>
              <a-select-option :value="4">港澳台通行证</a-select-option>
              <a-select-option :value="5">其他证件</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="证件号" name="idcard">
            <a-input v-model:value="tenantForm.idcard" placeholder="上传身份证自动获取"/>
          </a-form-item>
          <a-form-item label="证件地址" name="address">
            <a-input v-model:value="tenantForm.address" placeholder="上传身份证自动获取"/>
          </a-form-item>
          <a-form-item label="性别" name="sex">
            <a-select ref="select" v-model:value="tenantForm.sex" placeholder="上传身份证自动获取">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="手机号" name="phone" placeholder="手机号">
            <a-input v-model:value="tenantForm.phone" placeholder="手机号"/>
          </a-form-item>
          <a-form-item label="登记时间" name="create_time" placeholder="登记时间">
            <span>{{ tenantForm.create_time }}</span>
          </a-form-item>
          <a-form-item label="是否未成年" name="is_verify">
            <a-radio-group v-model:value="tenantForm.minority" button-style="solid">
              <a-radio-button :value="0">否</a-radio-button>
              <a-radio-button :value="1">是</a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="13">
          <a-form-item label="证件" name="papersFront">
            <div style="display: flex">
              <div>
                <div v-if="tenantForm.paperFrontUrl" class="image-box">
                  <a-image :height="102" :src="tenantForm.paperFrontUrl" :width="102" alt="avatar">
                  </a-image>
                  <div class="del-box" @click="
                    tenantForm.paperFrontUrl = '';
                  tenantForm.paperFront = [];
                  "></div>
                </div>
                <a-upload v-else v-model:file-list="tenantForm.paperFront" :action="action"
                          :before-upload="beforeUpload"
                          :data="upLoadData" :headers="upLoadHeader" :show-upload-list="false"
                          class="avatar-uploader" list-type="picture-card" name="image"
                          @change="upLoadChange($event, 'paperFrontUrl')">
                  <div>
                    <loading-outlined v-if="uploadLoading"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">证件正面</div>
                  </div>
                </a-upload>
              </div>
              <div>
                <div v-if="tenantForm.paperReserveUrl" class="image-box">
                  <a-image :height="102" :src="tenantForm.paperReserveUrl" :width="102" alt="avatar">
                  </a-image>
                  <div class="del-box" @click="
                    tenantForm.paperReserveUrl = '';
                  tenantForm.paperReserve = [];
                  "></div>
                </div>
                <a-upload v-else v-model:file-list="tenantForm.paperReserve" :action="action"
                          :before-upload="beforeUpload"
                          :data="upLoadData" :headers="upLoadHeader" :show-upload-list="false"
                          class="avatar-uploader" list-type="picture-card" name="image"
                          @change="upLoadChange($event, 'paperReserveUrl')">
                  <div>
                    <loading-outlined v-if="uploadLoading"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">证件反面</div>
                  </div>
                </a-upload>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="人脸验证" name="avatar">
            <div v-if="tenantForm.avatarUrl" class="image-box">
              <a-image :height="102" :src="tenantForm.avatarUrl" :width="102" alt="avatar">
              </a-image>
              <div class="del-box" @click="
                tenantForm.avatarUrl = '';
              tenantForm.avatar = [];
              "></div>
            </div>
            <a-upload v-else v-model:file-list="tenantForm.avatar" :action="action" :before-upload="beforeUpload"
                      :data="upLoadData" :headers="upLoadHeader" :show-upload-list="false"
                      class="avatar-uploader" list-type="picture-card" name="image"
                      @change="upLoadChange($event, 'avatarUrl')">
              <div>
                <loading-outlined v-if="uploadLoading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传头像</div>
              </div>
            </a-upload>
          </a-form-item>
          <a-form-item label="其他资料" name="other">
            <div style="display: flex; flex-wrap: wrap">
              <div v-for="(item, index) in tenantForm.other" :key="index" class="image-box">
                <a-image :height="102" :src="item.url" :width="102" alt="avatar">
                </a-image>
                <div class="del-box" @click="tenantForm.other.splice(index, 1)"></div>
              </div>
              <a-upload v-model:file-list="tenantForm.other" :action="action" :before-upload="beforeUpload"
                        :data="upLoadData"
                        :headers="upLoadHeader" :max-count="5" :show-upload-list="false"
                        list-type="picture-card" name="image" @change="upLoadChange($event, 'otherUrl')">
                <div v-if="tenantForm.other.length < 5">
                  <loading-outlined v-if="uploadLoading"></loading-outlined>
                  <plus-outlined v-else></plus-outlined>
                  <div class="ant-upload-text">上传资料</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </a-col>
        <template v-if="tenantForm.minority == 1">
          <a-col :span="11">
            <a-form-item label="监护人姓名" name="name">
              <a-input v-model:value="tenantForm.guarder_name" placeholder="监护人姓名"/>
            </a-form-item>
            <a-form-item label="监护人证件号" name="idcard">
              <a-input v-model:value="tenantForm.guarder_idcard" placeholder="监护人证件号"/>
            </a-form-item>
            <a-form-item label="监护人手机号" name="phone">
              <a-input v-model:value="tenantForm.guarder_phone" placeholder="监护人手机号"/>
            </a-form-item>
          </a-col>
          <a-col :span="13">
            <a-form-item label="监护人关系" name="type">
              <a-select ref="select" v-model:value="tenantForm.guarder_rela" placeholder="监护人关系">
                <a-select-option :value="1">父亲</a-select-option>
                <a-select-option :value="2">母亲</a-select-option>
                <a-select-option :value="3">老师</a-select-option>
                <a-select-option :value="9">其他</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="是否有同住人" name="type">
              <a-select ref="select" v-model:value="tenantForm.cohabit_has" placeholder="是否有同住人">
                <a-select-option :value="0">无同住人</a-select-option>
                <a-select-option :value="1">有同住人</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="同住人关系" name="type">
              <a-select ref="select" v-model:value="tenantForm.cohabit_rela" placeholder="同住人关系">
                <a-select-option :value="1">监护人</a-select-option>
                <a-select-option :value="2">同学</a-select-option>
                <a-select-option :value="9">其他</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </template>
      </a-row>
    </a-form>
    <template #footer>
      <a-button key="back" @click="closeTenantModal">取消</a-button>
      <a-button key="submit" :loading="addLoading" type="primary" @click="handleAddTenantConfirm">确定</a-button>
    </template>
  </a-modal>
  <!-- 分享入住 -->
  <a-modal v-model:visible="checkInGuideShow" :footer="null" title="分享入住" width="400px">
    <a-spin :spinning="guideSpin">
      <div class="guide">
        <div class="f-20 f-w-b">{{ orderDet.name }}（{{ orderDet.sname }}）</div>
        <div class="f-18">{{ orderDet.start_date }}入住，{{ orderDet.end_date }}退房</div>
        <div class="guide_img">
          <a-image :src="qrCode" height="250px" width="250px"/>
        </div>
        <div class="f-16">入住人员扫码登记入住</div>
      </div>
    </a-spin>
  </a-modal>
  <!-- 续住 -->
  <a-modal v-model:visible="stayoverShow" title="续住" @cancel="closeStayoverShow" @ok="handleStayoverConfirm">
    <div class="stay">
      <a-row align="center" justify="space-around" style="padding: 8px 0" type="flex">
        <a-col :span="6">
          <span class="f-c-999">房间名称</span>
        </a-col>
        <a-col :span="18">{{ orderDet.name }}</a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <span class="f-c-999">续住天数</span>
        </a-col>
        <a-col :span="6">
          <a-input-number id="inputNumber" v-model:value="stayoverDay" :max="99" :min="1" @change="dayChange"/>
        </a-col>
        <a-col :span="12"> {{ stayoverDate }} 退房</a-col>
      </a-row>
      <a-row style="padding: 8px 0">
        <a-col :span="6">
          <span class="f-c-999">房费</span>
        </a-col>
        <a-col :span="18">
          <a-input v-model:value="stayoverHousePrice" placeholder="续住产生的房费(选填)" style="width: 220px"/>
        </a-col>
      </a-row>
      <a-row style="padding: 8px 0">
        <a-col :span="6">
          <span class="f-c-999">收款</span>
        </a-col>
        <a-col :span="18">
          <a-input v-model:value="stayoverPaid" placeholder="已付金额(选填)" style="width: 220px"/>
        </a-col>
      </a-row>
      <a-row style="padding: 8px 0">
        <a-col :span="6">
          <span class="f-c-999">收款方式</span>
        </a-col>
        <a-col :span="18">
          <a-select v-model:value="stayoverPayment" placeholder="请选择收款方式" style="width: 220px">
            <a-select-option v-for="item in searchList.paytype.list" :key="item.id" :value="item.id">{{
                item.name
              }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>
  </a-modal>
  <!-- 换房 -->
  <change-room v-if="roomShow" :endDate="orderDet.end_date" :orderId="orderDet.id" :startDate="orderDet.start_date"
               @closeChangeRoom="roomShow = false" @confirmChangeRoom="confirmChangeRoom"/>
  <!-- 退款 -->
  <a-modal v-model:visible="showRefund" :width="500" class="refund" title="退款" @ok="refundSave">
    <a-form ref="formRefund" :label-col="{ span: 4 }" :model="orderDeposit" labelAlign="left">
      <a-form-item label="收款金额：">
        <div>
          {{ orderDeposit.amount }}
        </div>
      </a-form-item>
      <a-form-item label="收款时间：">
        <div>
          {{ orderDeposit.pay_time }}
        </div>
      </a-form-item>
      <a-form-item label="退押方式：">
        <div class="refund-switch">
          <div :class="{ refundSel: orderDeposit.refund_type == 1 }" class="switch-lef" @click="
            orderDeposit.refund_type = 1;
          orderDeposit.refund_amount = orderDeposit.amount;
          ">
            全额退款
          </div>
          <div :class="{ refundSel: orderDeposit.refund_type == 2 }" class="switch-rig" @click="
            orderDeposit.refund_type = 2;
          orderDeposit.refund_amount = '';
          ">
            非全额退款
          </div>
        </div>
      </a-form-item>
      <a-form-item :rules="[
        { required: true, message: '请输入退款金额', trigger: 'blur' },
      ]" label="金额：">
        <a-input v-model:value="orderDeposit.refund_amount" :disabled="orderDeposit.refund_type == 1"
                 placeholder="请输入退款金额, 0表示不退"
                 type="number"/>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 修改金额（再次申请退款） -->
  <a-modal v-model:visible="showRefundAgain" :width="500" class="refund" title="修改金额" @ok="refundAgainSave">
    <a-form ref="formRefundAgain" :label-col="{ span: 4 }" :model="refundAgainForm" labelAlign="left">
      <a-form-item label="订单号：">
        <div>
          {{ orderDet.order_no }}
        </div>
      </a-form-item>
      <a-form-item label="原押金：">
        <div>
          ￥{{ orderDeposit.amount }}
        </div>
      </a-form-item>
      <a-form-item label="已退款：">
        <div>
          ￥{{ orderDeposit.refund_amount || 0 }}
        </div>
      </a-form-item>
      <a-form-item label="剩余可退：">
        <div style="color: #ff4d4f; font-weight: bold;">
          ￥{{ (Number(orderDeposit.amount) - Number(orderDeposit.refund_amount || 0)).toFixed(2) }}
        </div>
      </a-form-item>
      <a-form-item :rules="[
        { required: true, message: '请输入退款金额', trigger: 'blur' },
      ]" label="退款金额：">
        <a-input v-model:value="refundAgainForm.refund_amount"
                 placeholder="请输入退款金额"
                 type="number"/>
        <div style="color: #999; font-size: 12px; margin-top: 4px;">
          退款金额不能超过剩余可退金额 ￥{{ (Number(orderDeposit.amount) - Number(orderDeposit.refund_amount || 0)).toFixed(2) }}
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  <!-- 修改订单 -->
  <EditOrder v-model:visible="showEditOrder" :orderId="order_id" @refresh="editOrderRefresh"></EditOrder>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {
  addCost,
  addTag,
  addTenant,
  delTenant,
  editHotelRemark,
  editTenant,
  getDayRemark,
  getGuideMiniQr,
  getIdcardInfo,
  getMiniAppid,
  getOrderDetail,
  getOrderLogList,
  getSearchList,
  getTenantDet,
  houseOpenlist,
  moveBoxOrder,
  orderCancel,
  orderCheckout,
  orderConfirmIn,
  orderDepositEdit,
  orderDepositRefund,
  orderDepositRefundAgain,
  orderGetOrderQrcode,
  orderReceiving,
  orderRevokeCheckin,
  orderSaveColor,
  orderTenantList,
  queryDepositPayStatus,
  pmsOrderEdit,
  pmsOrderSendSms,
  saveCheckInConfig,
  stayoverConfirm,
  tenantCheckin,
  tenantCheckout,
  updateDayRemark,
} from "@/api/api";
import {message, Modal} from "ant-design-vue";
import useClipboard from "vue-clipboard3";
import dayjs from "dayjs";
import {
  CloseOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  SyncOutlined,
} from "@ant-design/icons-vue";
import ChangeRoom from "../ChangeRoom/ChangeRoom.vue";
import EditOrder from "../EditOrder/EditOrder.vue";
import { baseRequestUrl } from "../../../../config.js";

export default {
  name: "order-details",
  components: {
    ChangeRoom,
    LoadingOutlined,
    PlusOutlined,
    CloseOutlined,
    EditOrder,
    SyncOutlined,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    orderId: {
      default: "",
    },
    tab: {
      default: 1,
    },
    other: {
      default: {},
    },
    showDayRemark: {
      type: Boolean,
      default: false,
    },
    remarkDay: {
      default: "",
    },
  },
  emits: ["update:visible", "refreshOrderDetails", "changeRoom"],
  setup(props, {emit}) {
    // 修改订单
    const editOrder = reactive({
      showEditOrder: false,
      editOrderRefresh() {
        emit("refreshOrderDetails");
      },
    });

    // 订单详情
    const details = reactive({
      spinning: false,
      roomShow: false, //打开换房
      logo: JSON.parse(sessionStorage.getItem("companyInfo") || '{}').logo || '',
      show: false,
      tagShow: false,
      accountShow: false,
      remarkShow: false,
      editPhone: false,
      editPwd: false,
      sendSmsMsg: '',
      activeKey: 1,
      orderDet: {},
      orderLogList: [],
      orderDeposit: "",
      otherOrder: [],
      appid: "",
      selTag: [],
      uploadLoading: false,
      // 上传图片
      action:
          baseRequestUrl + "/h5/upload/uploadImg?info=" +
          JSON.parse(sessionStorage.getItem("landlordInfo")).info,
      upLoadData: {
        module: "pms",
        type: "order",
      },
      upLoadHeader: {
        token: JSON.parse(sessionStorage.getItem("landlordInfo")).token,
        version: "1.0.0",
        source: "1",
      },
      tenantList: [],
      costList: [],
      order_id: "",
      tenantColumns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "手机",
          dataIndex: "phone",
        },
        {
          title: "身份证",
          dataIndex: "idcard",
        },
        {
          title: "",
          dataIndex: "oper",
          key: "oper",
        },
      ],
      costColumns: [
        {
          title: "类型",
          dataIndex: "inout_name",
        },
        {
          title: "金额",
          key: "income",
        },
        {
          title: "交易方式",
          dataIndex: "paytype_name",
        },
        {
          title: "交易时间",
          dataIndex: "create_time",
        },
      ],
      logColumns: [
        {
          title: "时间",
          dataIndex: "create_time",
          width: 200,
          key: "create_time"
        },
        {
          title: "备注",
          dataIndex: "content",
          key: "content"
        },
      ],
      tabBarStyle: {
        position: "fixed",
        backgroundColor: "#fff",
        width: "100%",
        zIndex: "99",
      },
      accountRef: "",
      accountForm: {
        type: "1",
        project: [],
        price: "",
        mode: [],
        date: "",
        image: "",
        imageUrl: "",
        remark: "",
      },
      remarkText: "",

      showOpenList: false,
      openList: [], //开门记录
      openListTotal: "", //开门记录分页
      openListStart: 0,
      openListLimit: 10,
      columns: [
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "开门方式",
          dataIndex: "type_text",
          key: "type_text",
        },
        {
          title: "开门时间",
          dataIndex: "open_date",
          key: "open_date",
        },
      ],
      showCostList: false,
      qrCode: "",
      other: {},
      // 换房
      handleChangeRoom() {
        if (props.showDayRemark) {
          const params = {
            order_id: details.order_id,
            stockId: details.orderDet.stockId,
            start_date: details.orderDet.start_date,
            type: details.orderDet.order_type,
            orderInfo: {
              nights: details.orderDet.nights,
            },
          };
          emit("changeRoom", params);
        } else {
          details.showEditOrder = true;
        }
        details.handleCloseDrawer();
      },
      // 订单颜色标记保存
      saveOrderColor() {
        orderSaveColor({
          orderId: details.order_id,
          color: details.orderDet.color,
          colorName: details.searchList.color.list.filter(
              (i) => i.color == details.orderDet.color
          ).length
              ? details.searchList.color.list.filter(
                  (i) => i.color == details.orderDet.color
              )[0].name
              : "",
        }).then((res) => {
          message.success(res.msg);
          details.getOrderDetail(details.orderDet.id);
          emit("refreshOrderDetails");
        });
      },
      // 订单切换
      selOrder(item) {
        details.getOrderDetail(item.id);
      },

      // 切换tabs
      handleChangeTabs() {
        if (details.activeKey == 2) {
          details.dayRemark();
        } else if (details.activeKey == 4) {
          details.orderLog();
        }

      },
      // 获取日期备忘
      dayRemark() {
        getDayRemark({
          hid: details.orderDet.hid,
          date: props.remarkDay ? props.remarkDay : details.orderDet.start_date,
        }).then((res) => {
          details.orderDet.dayRemark = res.data.remark;
        });
      },
      // 获取订单日志
      orderLog() {
        getOrderLogList({
          order_id: details.orderDet.id,
        }).then((res) => {
          console.log(res)
          details.orderLogList = res.data;
        });
      },
      // 保存日期备忘
      saveDateRemark() {
        updateDayRemark({
          hid: details.orderDet.hid,
          date: props.remarkDay ? props.remarkDay : details.orderDet.start_date,
          remark: details.orderDet.dayRemark,
        }).then((res) => {
          message.success(res.msg);
          details.getOrderDetail(details.order_id);
          emit("refreshOrderDetails");
        });
      },
      // 获取小程序二维码
      getMiniCode() {
        getMiniAppid({
          appId: 2,
        }).then((res) => {
          details.appid = res.data.appidMini;
          getGuideMiniQr({
            orderId: details.order_id,
            type: 2,
            page: "pages/authorzation/index",
            appid: res.data.appidMini,
          }).then((res) => {
            details.qrCode = res.data.miniQr;
            opers.guideSpin = false;
          });
        });
      },
      // 获取二维码
      getQrCode() {
        orderGetOrderQrcode({
          order_id: details.order_id,
        }).then((res) => {
          details.qrCode = res.data.qrcode_url;
        });
      },
      // 处理操作
      handleOper(s) {
        let title = "";
        let contents = "";
        if (s == 1) {
          title = "确定改为入住状态？";
          contents = "请确认房客已经实际入住";
        } else if (s == 2) {
          title = "取消订单？";
        } else if (s == 3) {
          title = "确认订单？";
        } else if (s == 4) {
          title = "确定退房？";
        } else if (s == 5) {
          title = "撤销入住？";
        }
        Modal.confirm({
          title: title,
          content: contents,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            switch (s) {
              case 1:
                orderConfirmIn({order_id: details.order_id}).then((res) => {
                  message.success(res.msg);
                  details.getOrderDetail(details.order_id);
                  emit("refreshOrderDetails");
                });
                break;
              case 2:
                orderCancel({order_id: details.order_id}).then((res) => {
                  message.success(res.msg);
                  details.getOrderDetail(details.order_id);
                  emit("refreshOrderDetails");
                });
                break;
              case 3:
                orderReceiving({order_id: details.order_id}).then((res) => {
                  message.success(res.msg);
                  details.getOrderDetail(details.order_id);
                  emit("refreshOrderDetails");
                });
                break;
              case 4:
                orderCheckout({order_id: details.order_id}).then((res) => {
                  message.success(res.msg);
                  details.getOrderDetail(details.order_id);
                  emit("refreshOrderDetails");
                });
                break;
              case 5:
                orderRevokeCheckin({order_id: details.order_id}).then(
                    (res) => {
                      message.success(res.msg);
                      details.getOrderDetail(details.order_id);
                      emit("refreshOrderDetails");
                    }
                );
                break;
            }
          },
        });
      },
      // 手动关闭
      handleCloseDrawer() {
        details.show = false;
      },
      // 展示开门记录
      handleOpenList() {
        if (!details.showOpenList) {
          details.showOpenList = true;
          details.openListStart = 0;
          details.openListLimit = 10;
          details.getOpenList();
        } else {
          details.showOpenList = false;
        }
      },
      // 获取开门记录
      getOpenList() {
        details.openList = [];
        houseOpenlist({
          orderid: details.orderDet.id,
          start: details.openListStart,
          limit: details.openListLimit,
        }).then((res) => {
          for (let item of res.data.list) {
            details.openList.push(...item.list);
          }
          details.openListTotal = res.data.count;
        });
      },
      pageChange(value) {
        details.openListStart = (value - 1) * details.openListLimit;
        details.getOpenList();
      },
      onShowSizeChange(value) {
        details.openListLimit = value;
        details.getOpenList();
      },
      // 标签背景色
      handleStatusColor(params) {
        if (params.status == 3) {
          return "#008000";
        } else if (params.status == 4) {
          return "#fe5300";
        } else if (params.status == 5) {
          return "#999999";
        } else {
          return "#666666";
        }
      },
      // 编辑时间
      editTime(s) {
        if (s == 1) {
          tenantCheckin({
            order_id: details.order_id,
            in_time: dayjs(details.editInTime).format("HH:mm"),
          }).then((res) => {
            message.success(res.msg);
            emit("refreshOrderDetails");
            setTimeout(() => {
              details.getOrderDetail(details.order_id);
            }, 500);
          });
        } else {
          tenantCheckout({
            order_id: details.order_id,
            out_time: dayjs(details.editOutTime).format("HH:mm"),
          }).then((res) => {
            message.success(res.msg);
            emit("refreshOrderDetails");
            setTimeout(() => {
              details.getOrderDetail(details.order_id);
            }, 500);
          });
        }
      },
      // 关闭回调
      onClose() {
        emit("closeOrderDetails");
      },
      // 备注
      handleEditRemark() {
        editHotelRemark({
          order_id: details.order_id,
          remark: details.orderDet.company_remark,
        })
            .then((res) => {
              message.success(res.msg);
              details.getOrderDetail(details.order_id);
              emit("refreshOrderDetails");
            })
            .finally(() => {
              details.remarkShow = false;
              details.getOrderDetail(details.order_id);
            });
      },
      // 修改手机号
      handleEditPhone() {
        pmsOrderEdit({
          order_id: details.order_id,
          tphone: details.orderDet.tphone,
        })
            .then((res) => {
              message.success(res.msg);
              details.editPhone = false;
              details.getOrderDetail(details.order_id);
            })
            .finally(() => {
            });
      },
      //取消编辑手机号
      cencelEditPhone() {
        details.editPhone = false;
        details.getOrderDetail(details.order_id);
      },
      // 修改密码
      handleEditPwd() {
        saveCheckInConfig({
          orderId: details.order_id,
          lock_pwd: details.orderDet.lock_pwd,
        })
            .then((res) => {
              message.success(res.msg);
              details.editPwd = false;
              details.getOrderDetail(details.order_id);
            })
            .finally(() => {
            });
      },
      //取消编辑密码
      cencelEditPwd() {
        details.editPwd = false;
        details.getOrderDetail(details.order_id);
      },

      //发送短信
      sendSms() {
        this.sendSmsMsg = '(正在发送...)'
        pmsOrderSendSms({
          order_id: details.order_id,
        })
            .then((res) => {
              message.success(res.msg);
              this.sendSmsMsg = '(发送成功)'
            })
            .finally(() => {
            }).catch((error) => {
          this.sendSmsMsg = '(' + error.msg + ')'
        });
      },

      // 记账 选择时间
      accountDateOk(v, s) {
        details.accountForm.date = s;
      },

      // 上传图片回调
      upLoadChange(info, type) {
        if (info.file.status === "uploading") {
          details.uploadLoading = true;
          return;
        }
        if (info.file.status === "done") {
          if (type == "imageUrl") {
            details.accountForm[type] = info.file.response.data.url;

            details.uploadLoading = false;
            details.accountRef.validate("imageUrl");
            return;
          }
          opers.tenantForm[type] = info.file.response.data.url;
          if (
              type == "paperFrontUrl" ||
              type == "paperReserveUrl" ||
              type == "avatarUrl" ||
              type == "antiepidemicHealthCodeUrl" ||
              type == "antiepidemicTravelCodeUrl"
          ) {
            opers.tenantForm[type.slice(0, type.indexOf("Url"))] = [
              {
                url: info.file.response.data.url,
                id: info.file.response.data.id,
              },
            ];
          } else {
            opers.tenantForm[type.slice(0, type.indexOf("Url"))] =
                info.fileList.map((item) => {
                  return {
                    id: item.response ? item.response.data.id : item.id,
                    url: item.response ? item.response.data.url : item.url,
                  };
                });
          }
          details.uploadLoading = false;
          if (type == "paperFrontUrl" || type == "paperReserveUrl") {
            console.log(type)
            getIdcardInfo({
              [type == "paperFrontUrl" ? "cert_front" : "cert_back"]:
              info.file.response.data.url,
              order_id: details.order_id,
              type: opers.tenantForm.type
            }).then((res) => {
              if (type == "paperFrontUrl") {
                opers.tenantForm = {...res.data, ...opers.tenantForm};
                opers.tenantForm.name = res.data.name;
                opers.tenantForm.idcard = res.data.idcard;
                opers.tenantForm.address = res.data.address;
                opers.tenantForm.sex = res.data.sex;
                if (res.data.age < 18) {
                  opers.tenantForm.minority = 1
                }
              } else if (type == "paperReserveUrl") {
                opers.tenantForm = {...res.data, ...opers.tenantForm};
                opers.tenantForm.authority = res.data.organ;
                opers.tenantForm.timelimit = res.data.period;
              }
            });
          }
        }
        if (info.file.status === "error") {
          details.uploadLoading = false;
          message.error("上传错误");
        }
      },

      // 记账
      handleAddAccount() {
        details.accountRef.validate().then(() => {
          addCost({
            order_id: details.order_id,
            inout_id: details.accountForm.project,
            paytype_id: details.accountForm.mode,
            type: details.accountForm.type,
            price: details.accountForm.price,
            remark: details.accountForm.remark,
            image: details.accountForm.imageUrl,
            cost_time: details.accountForm.date,
          }).then((res) => {
            message.success(res.msg);
            details.accountRef.resetFields();
            details.accountForm.date = "";
            details.accountForm.remark = "";
            details.accountShow = false;
            details.getOrderDetail(details.order_id);
            // emit("refreshOrderDetails");
            // search.getOrderList();
          });
        });
      },

      // 上传图片钩子
      beforeUpload(file) {
        const isJpgOrPng =
            file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          message.error("只能上传jpg、png格式图片!");
        }
        return isJpgOrPng;
      },
      // 复制订单号
      handleCopy() {
        try {
          useClipboard().toClipboard(details.orderDet.order_no);
          message.success("复制成功");
        } catch (error) {
          message.error("复制失败");
        }
      },
      // 添加标签
      handleAddTags() {
        addTag({
          order_id: details.order_id,
          tag: details.selTag.join(","),
        }).then(() => {
          details.tagShow = false;
          details.getOrderDetail(details.order_id);
          emit("refreshOrderDetails");
          //   search.getOrderList();
        });
      },
      tenantDet: "",
      searchList: {
        checkIdentity: [],
        epidemicInfo: [],
        register: [],
        certificateRequirements: [],
        color: [],
        verifyMode: [],
      },
      getSearch() {
        // 获取查询参数列表
        getSearchList().then((res) => {
          details.searchList = res.data;
        });
      },
      editInTime: "",
      editOutTime: "",
      tenantTimer: "",
      tenantTimerNum: 0,
      // 获取住客列表
      getTenantList(orderId) {
        details.tenantTimerNum += 1;
        if (details.tenantTimerNum > 100) {
          clearInterval(details.tenantTimer);
        }
        orderTenantList({
          order_id: orderId,
        }).then((res) => {
          details.tenantList = res.data;
        });
      },
      // 读取订单详情
      getOrderDetail(orderId) {
        checkinMange.editDeposit = false;
        details.remarkShow = false;
        details.showOpenList = false;
        details.spinning = true;
        details.selTag = [];
        clearInterval(details.tenantTimer);
        details.tenantTimerNum = 0;
        let params;
        if (orderId) {
          params = {
            order_id: orderId,
          };
        } else {
          params = {
            hid: details.other.hid,
            date: details.other.date,
          };
        }
        getOrderDetail(params)
            .then((res) => {
              details.order_id = res.data.order_details.id;
              stayover.stayoverDate = dayjs(res.data.order_details.end_date)
                  .add(1, "day")
                  .format("YYYY-MM-DD");
              details.detShow = true;
              details.orderDeposit = res.data.order_deposit;
              details.orderDet = res.data.order_details;
              details.otherOrder = res.data.other_order;
              details.orderDet.open_fun = res.data.order_details.open_fun
                  ? res.data.order_details.open_fun.split(",").map(Number)
                  : [];
              details.tenantDet = res.data.tenant_list;
              details.tenantList = res.data.tenant_list.list;
              details.costList = res.data.cost_list;
              let s = res.data.order_details.gid
                  ? res.data.order_details.gid.split(",")
                  : [];
              s.forEach((item) => {
                details.selTag.push(Number(item));
              });
              if (details.tenantDet.in_time) {
                details.editInTime = dayjs(
                    dayjs(details.tenantDet.in_time).format("HH:mm"),
                    "HH:mm"
                );
                details.tenantDet.in_time = dayjs(
                    details.tenantDet.in_time
                ).format("YYYY-MM-DD");
              }
              if (details.tenantDet.out_time) {
                details.editOutTime = dayjs(
                    dayjs(details.tenantDet.out_time).format("HH:mm"),
                    "HH:mm"
                );
                details.tenantDet.out_time = dayjs(
                    details.tenantDet.out_time
                ).format("YYYY-MM-DD");
              }
              // 定时获取住客列表
              if (details.orderDet.status == 3 || details.orderDet.status == 4) {
                details.tenantTimer = setInterval(() => {
                  details.getTenantList(details.order_id);
                }, 5000);
              }
              details.spinning = false;
              nextTick(() => {
                if (details.activeKey == 2) {
                  details.dayRemark();
                }
              });
            })
            .catch(() => {
              details.onClose();
            });
      },
    });

    // 订单操作
    const opers = reactive({
      addForm: {
        users: [
          {
            name: "",
            phone: "",
            idcard: "",
          },
        ],
      },
      addLoading: false,
      addTenantTitle: "添加房客",
      tenantShow: false,
      tenantRef: "",
      tenantType: "",
      tenantItem: "",
      initTenantForm() {
        return {
          name: "",
          phone: "",
          idcard: "",
          address: "",
          is_verify: 1,
          sex: 1,
          type: 1,
          other: [],
          otherUrl: "",
          paperFront: [],
          paperFrontUrl: "",
          paperReserve: [],
          paperReserveUrl: "",
          avatar: [],
          avatarUrl: "",
          antiepidemic: [],
          antiepidemicHealthCodeUrl: "",
          antiepidemicHealthCode: [],
          antiepidemicTravelCode: [],
          antiepidemicTravelCodeUrl: "",
          minority: 0,
          cohabit_rela: [],
          cohabit_has: [],
          guarder_phone: "",
          guarder_idcard: "",
          guarder_name: "",
          guarder_rela: [],
          kyqk: 0,
          kyqkms: "",
        };
      },
      tenantForm: {},
      // 移入订单盒子
      moveBoxOrder() {
        Modal.confirm({
          title: "提示",
          content: "是否撤销排房?",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            moveBoxOrder({
              order_id: details.orderDet.id,
            }).then((res) => {
              message.success(res.msg);
              emit("refreshOrderDetails");
            });
          },
        });
      },
      // 添加房客 弹窗
      handleAddTenant() {
        opers.tenantShow = true;
        opers.tenantType = 1;
        opers.addTenantTitle = "添加房客";
        opers.tenantForm = opers.initTenantForm();
        opers.tenantForm.avatarUrl = "";
        opers.tenantForm.avatar = [];
      },
      handleEditTenant(item, s) {
        opers.tenantForm = opers.initTenantForm();
        opers.tenantItem = item;
        opers.tenantShow = true;
        opers.tenantType = 2;
        opers.addTenantTitle = s == 1 ? "编辑房客" : "查看房客";
        getTenantDet({
          id: item.id,
        }).then((res) => {
          opers.tenantForm = {
            ...res.data,
            paperFrontUrl: res.data.cert_front.url,
            paperFront: res.data.cert_front.id ? [res.data.cert_front] : [],
            paperReserveUrl: res.data.cert_back.url,
            paperReserve: res.data.cert_back.id ? [res.data.cert_back] : [],
            avatarUrl: res.data.head.url,
            avatar: res.data.head.id ? [res.data.head] : [],
            antiepidemicHealthCodeUrl: res.data.epidemic_healthy.url,
            antiepidemicHealthCode: res.data.epidemic_healthy.id
                ? [res.data.epidemic_healthy]
                : [],
            antiepidemicTravelCodeUrl: res.data.epidemic_trip.url,
            antiepidemicTravelCode: res.data.epidemic_trip.id
                ? [res.data.epidemic_trip]
                : [],
            other: res.data.other_imgs,
            guarder_rela:
                res.data.guarder_rela > 0 ? [res.data.guarder_rela] : [],
            cohabit_has: [res.data.cohabit_has],
            cohabit_rela:
                res.data.cohabit_rela > 0 ? [res.data.cohabit_rela] : [],
          };
        });
      },
      // 删除房客
      handleDelTenant(item) {
        Modal.confirm({
          title: "提示",
          content: "是否删除?",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            delTenant({
              order_id: details.orderDet.id,
              tenant_id: item.id,
            }).then((res) => {
              message.success(res.msg);
              details.getOrderDetail(details.orderDet.id);
              // emit("refreshOrderDetails");//删除不刷新房态
            });
          },
        });
      },
      // 关闭入住人弹窗
      closeTenantModal() {
        opers.tenantShow = false;
      },
      // 添加 编辑 房客确认
      handleAddTenantConfirm() {
        opers.tenantRef.validate().then(() => {
          opers.addLoading = true;
          if (opers.tenantType == 1) {
            addTenant({
              cert_front: opers.tenantForm.paperFront.length
                  ? JSON.stringify(opers.tenantForm.paperFront)
                  : "",
              cert_back: opers.tenantForm.paperReserve.length
                  ? JSON.stringify(opers.tenantForm.paperReserve)
                  : "",
              head: opers.tenantForm.avatar.length
                  ? JSON.stringify(opers.tenantForm.avatar)
                  : "",
              epidemic_healthy: opers.tenantForm.antiepidemicHealthCode.length
                  ? JSON.stringify(opers.tenantForm.antiepidemicHealthCode)
                  : "",
              epidemic_trip: opers.tenantForm.antiepidemicTravelCode.length
                  ? JSON.stringify(opers.tenantForm.antiepidemicTravelCode)
                  : "",
              other_imgs: opers.tenantForm.other.length
                  ? JSON.stringify(opers.tenantForm.other)
                  : "",
              order_id: details.orderDet.id,
              type: opers.tenantForm.type,
              name: opers.tenantForm.name,
              phone: opers.tenantForm.phone,
              idcard: opers.tenantForm.idcard,
              sex: opers.tenantForm.sex,
              nation: opers.tenantForm.nation,
              year: opers.tenantForm.year,
              month: opers.tenantForm.month,
              day: opers.tenantForm.day,
              address: opers.tenantForm.address,
              timelimit: opers.tenantForm.timelimit,
              authority: opers.tenantForm.authority,
              is_verify: opers.tenantForm.is_verify,
              minority: opers.tenantForm.minority,
              guarder_rela: opers.tenantForm.guarder_rela.toString(),
              guarder_name: opers.tenantForm.guarder_name,
              guarder_idcard: opers.tenantForm.guarder_idcard,
              guarder_phone: opers.tenantForm.guarder_phone,
              cohabit_has: opers.tenantForm.cohabit_has.toString(),
              cohabit_rela: opers.tenantForm.cohabit_rela.toString(),
            })
                .then((res) => {
                  message.success(res.msg);
                  opers.tenantRef.resetFields();
                  opers.tenantShow = false;
                  details.getOrderDetail(details.orderDet.id);
                  emit("refreshOrderDetails");
                })
                .finally(() => {
                  opers.addLoading = false;
                });
          } else {
            editTenant({
              cert_front: opers.tenantForm.paperFront.length
                  ? JSON.stringify(opers.tenantForm.paperFront)
                  : "",
              cert_back: opers.tenantForm.paperReserve.length
                  ? JSON.stringify(opers.tenantForm.paperReserve)
                  : "",
              head: opers.tenantForm.avatar.length
                  ? JSON.stringify(opers.tenantForm.avatar)
                  : "",
              epidemic_healthy: opers.tenantForm.antiepidemicHealthCode.length
                  ? JSON.stringify(opers.tenantForm.antiepidemicHealthCode)
                  : "",
              epidemic_trip: opers.tenantForm.antiepidemicTravelCode.length
                  ? JSON.stringify(opers.tenantForm.antiepidemicTravelCode)
                  : "",
              other_imgs: opers.tenantForm.other.length
                  ? JSON.stringify(opers.tenantForm.other)
                  : "",
              id: opers.tenantItem.id,
              order_id: details.orderDet.id,
              type: opers.tenantForm.type,
              name: opers.tenantForm.name,
              phone: opers.tenantForm.phone,
              idcard: opers.tenantForm.idcard,
              sex: opers.tenantForm.sex,
              nation: opers.tenantForm.nation,
              year: opers.tenantForm.year,
              month: opers.tenantForm.month,
              day: opers.tenantForm.day,
              address: opers.tenantForm.address,
              timelimit: opers.tenantForm.timelimit,
              authority: opers.tenantForm.authority,
              is_verify: opers.tenantForm.is_verify,
              minority: opers.tenantForm.minority,
              guarder_rela: opers.tenantForm.guarder_rela.toString(),
              guarder_name: opers.tenantForm.guarder_name,
              guarder_idcard: opers.tenantForm.guarder_idcard,
              guarder_phone: opers.tenantForm.guarder_phone,
              cohabit_has: opers.tenantForm.cohabit_has.toString(),
              cohabit_rela: opers.tenantForm.cohabit_rela.toString(),
            })
                .then((res) => {
                  message.success(res.msg);
                  opers.tenantRef.resetFields();
                  opers.tenantShow = false;
                  details.getOrderDetail(details.orderDet.id);
                  // emit("refreshOrderDetails");//刷新房态
                })
                .finally(() => {
                  opers.addLoading = false;
                });
          }
        });
      },
      // 添加用户
      handleAddPerson() {
        opers.addForm.users.push({
          name: "",
          phone: "",
          idcard: "",
        });
      },
      // 删除用户
      handleDelPerson(item) {
        if (opers.addForm.users.length == 1) {
          message.warn("至少添加一个入住人!");
          return;
        }
        let index = opers.addForm.users.indexOf(item);
        if (index != -1) {
          opers.addForm.users.splice(index, 1);
        }
      },

      // 入住指南
      checkInGuideShow: false,
      guideImg: "",
      guide_url: "",
      guideSpin: false,
      // 复制入住指南链接
      handleCopyGuideUrl() {
        try {
          useClipboard().toClipboard(opers.guide_url);
          message.success("复制成功");
        } catch (error) {
          message.error("复制失败");
        }
      },
      checkInGuide() {
        details.qrCode = "";
        opers.guideSpin = true;
        details.getMiniCode();
        opers.checkInGuideShow = true;
      },
    });

    // 入住管理
    const checkinMange = reactive({
      editDeposit: false,
      // 换房f
      confirmChangeRoom() {
        emit("refreshOrderDetails");
        details.getOrderDetail(details.orderDet.id);
      },

      // 押金修改
      editDepositSave(params) {
        orderDepositEdit({
          depositId: details.orderDeposit.id,
          ...params,
        }).then((res) => {
          checkinMange.editDeposit = false;
          message.success(res.msg);
          details.getOrderDetail(details.orderDet.id);
        });
      },
      // 确认修改
      checkConfirm(params) {
        saveCheckInConfig({
          orderId: details.orderDet.id,
          ...params,
        }).then((res) => {
          checkinMange.editDeposit = false;
          message.success(res.msg);
          details.getOrderDetail(details.orderDet.id);
        });
      },
    });

    // 续住
    const stayover = reactive({
      stayoverShow: false,
      stayoverDay: 1,
      stayoverHousePrice: "",
      stayoverPaid: "",
      stayoverPayment: 100,
      stayoverDate: "",
      // 打开续住弹窗
      openStayover() {
        stayover.stayoverShow = true;
      },
      //  续住 确定
      handleStayoverConfirm() {
        if (!stayover.stayoverPayment) {
          message.success("请选择收款方式");
          return;
        }
        stayoverConfirm({
          orderId: details.orderDet.id,
          day: stayover.stayoverDay,
          housePrice: stayover.stayoverHousePrice,
          receipt: stayover.stayoverPaid,
          receiptTypeId: stayover.stayoverPayment,
          receiptType: details.searchList.paytype.list.find(
              (item) => item.id == stayover.stayoverPayment
          ).name,
          date: stayover.stayoverDate,
        }).then((res) => {
          emit("refreshOrderDetails");
          message.success(res.msg);
          details.getOrderDetail(details.orderDet.id);
          stayover.closeStayoverShow();
        });
      },
      dayChange(e) {
        stayover.stayoverDate = dayjs(details.orderDet.end_date)
            .add(e, "day")
            .format("YYYY-MM-DD");
      },
      // 关闭续住弹窗
      closeStayoverShow() {
        stayover.stayoverShow = false;
        stayover.stayoverHousePrice = "";
        stayover.stayoverPaid = "";
        stayover.stayoverPayment = "";
        stayover.stayoverDay = 1;
        stayover.stayoverDate = dayjs(details.orderDet.end_date)
            .add(1, "day")
            .format("YYYY-MM-DD");
      },
    });

    // 退款
    const refund = reactive({
      formRefund: "",
      showRefund: false,
      showRefundAgain: false,
      formRefundAgain: "",
      refundAgainForm: {
        refund_amount: "",
      },
      openRefund() {
        details.orderDeposit.refund_type = 1;
        details.orderDeposit.refund_amount = details.orderDeposit.amount;
        refund.showRefund = true;
      },
      openRefundAgain() {
        refund.refundAgainForm.refund_amount = "";
        refund.showRefundAgain = true;
      },
      refundSave() {
        refund.formRefund.validate().then(() => {
          orderDepositRefund({
            depositId: details.orderDeposit.id,
            refundPrice: details.orderDeposit.refund_amount,
            refundType: details.orderDeposit.refund_type,
          }).then((res) => {
            message.success(res.msg);
            refund.showRefund = false;
            details.getOrderDetail(details.orderDet.id);
          });
        });
      },
      refundAgainSave() {
        refund.formRefundAgain.validate().then(() => {
          const maxRefund = Number(details.orderDeposit.amount) - Number(details.orderDeposit.refund_amount || 0);
          const refundAmount = Number(refund.refundAgainForm.refund_amount);
          if (refundAmount <= 0) {
            message.error("退款金额必须大于0");
            return;
          }
          if (refundAmount > maxRefund) {
            message.error(`退款金额不能超过剩余可退金额 ￥${maxRefund.toFixed(2)}`);
            return;
          }
          orderDepositRefundAgain({
            order_no: details.orderDet.order_no,
            refund_amount: refund.refundAgainForm.refund_amount,
            refundType: 2,
          }).then((res) => {
            message.success(res.msg);
            refund.showRefundAgain = false;
            details.getOrderDetail(details.orderDet.id);
            emit("refreshOrderDetails");
          });
        });
      },
      // 刷新支付状态
      refreshPayStatus() {
        queryDepositPayStatus({
          order_id: details.order_id,
        }).then(() => {
          details.getOrderDetail(details.order_id);
        });
      },
      // 免押
      depositFree() {
        Modal.confirm({
          title: "确认免押吗?",
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            checkinMange.editDepositSave({
              amount: 0,
            });
          },
        });
      },
    });

    watch(props, () => {
      details.show = props.visible;
      details.sendSmsMsg = '';
      if (props.visible) {
        if (props.orderId) {
          details.getOrderDetail(props.orderId);
        } else {
          details.other = props.other;
          details.getOrderDetail();
        }
        details.getSearch();
      }
      if (props.tab) {
        details.activeKey = props.tab;
      }
    });

    watch(
        () => details.show,
        (value) => {
          if (!value) {
            clearInterval(details.tenantTimer);
          }
          emit("update:visible", value);
        }
    );

    onMounted(() => {
    });

    return {
      ...toRefs(details),
      ...toRefs(opers),
      ...toRefs(checkinMange),
      ...toRefs(stayover),
      ...toRefs(refund),
      ...toRefs(editOrder),
      dayjs,
    };
  },
};
</script>
<style lang="scss">
.image-box {
  position: relative;
  width: 102px;
  margin: 0 8px 8px 0;

  .del-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: #00000044;
    border-radius: 0 0 0 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: "X";
      color: #fff;
      cursor: pointer;
    }
  }
}

.ant-image-img {
  height: 100%;
  object-fit: cover;
}

.color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  position: relative;
}

.order-tab {
  padding: 6px 15px;
  background-color: #f5f5f5;
  display: flex;
  overflow: auto;
  margin: 10px 0 20px 0;

  .selOrder {
    background-color: #fff;
    border: 1px solid #0094ff;
    border-radius: 10px;
  }

  .order-box {
    width: 200px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 5px 5px;
    background-color: white;
    margin-right: 10px;
    border-radius: 5px;
    cursor: pointer;

    .order-source {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 5px;
    }

    .order-info {
      font-size: 12px;
    }
  }
}

.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

// 添加标签
.addTags {
  display: flex;
  flex-wrap: wrap;

  .tag-cell {
    color: #fff;
    padding: 3px 5px;
    margin: 5px;
    border-radius: 3px;
  }
}

.qrcode {
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  height: 500px;
}

.ant-drawer-body {
  padding-top: 0 !important;
}

.guide {
  text-align: center;

  .guide_img {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .guide_text {
    color: #0094ff;
    cursor: pointer;
  }
}

// 订单详情
.detail {
  .operate {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    width: calc(100% - 48px);
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .operate-lef {
    }

    .operate-rig {
    }
  }

  .det-head {
    .ant-tabs-nav {
      height: 50px;
    }

    .refresh {
      z-index: 999;
      position: fixed;
      right: 60px;
      top: 7px;
      cursor: pointer;

      &:hover {
        color: #000000;
      }
    }

    .close {
      z-index: 999;
      position: fixed;
      right: 24px;
      top: 7px;
      cursor: pointer;

      &:hover {
        color: #000000;
      }
    }

    .detail-info {
      padding-top: 60px;
      color: #000000;

      .head-house {
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 6px;
        margin-bottom: 10px;

        .house-top {
          display: flex;
          align-items: center;
          margin-bottom: 6px;

          .top-img {
            margin-right: 10px;
          }

          .top-text {
            display: flex;
            flex: 1;
            justify-content: space-between;

            .text_left {
              .text-name {
                width: 260px;
              }

              .text-type {
                color: #ccc;
                font-size: 12px;
              }
            }

            .text_right {
              color: #0094ff;
              cursor: pointer;
            }
          }
        }

        .house-bom {
          font-size: 12px;
          color: #999;
        }
      }

      .head-tag {
        display: flex;
        flex-wrap: wrap;

        // border-bottom: 1px solid #f3f3f3;
        // padding-bottom: 10px;
        // margin-bottom: 10px;
        .tag-btn {
          padding: 3px 10px;
          margin: 5px;
          border-radius: 3px;
          color: #fff !important;
          background-color: #0094ff;

          .ant-checkbox {
            color: #ffffff !important;
          }
        }

        .tag-btn-g {
          padding: 3px 10px;
          margin: 5px;
          border-radius: 3px;
          color: #999;
          background-color: #ebebeb;
          cursor: pointer;
        }
      }

      .head-info {
        border-bottom: 1px solid #f3f3f3;
        padding-bottom: 10px;
        margin-bottom: 10px;

        .info-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;
          height: 30px;

          .title-left {
            font-size: 14px;
            font-weight: bold;
          }

          .title-right {
            color: #0094ff;
          }
        }

        .info-cont {
          .cont-cell {
            display: flex;
            margin-bottom: 10px;
            align-items: center;

            .cell-title {
              width: 100px;
              color: #999;
              text-align: left;
              display: flex;
            }

            .cell-data {
              flex: 1;

              .link {
                color: #0094ff;
                cursor: pointer;
              }

              .data-check {
                display: flex;
                align-items: center;

                .data-val {
                  flex: 8;
                }

                .data-con {
                  flex: 2;
                }
              }

              .det {
                color: #0094ff;
              }

              .copy {
                font-size: 12px;
                cursor: pointer;
                padding: 2px 5px;
                border: 1px solid #f3f3f3;
                border-radius: 4px;
              }

              .cell-tab {
                border-radius: 5px;
                padding: 2px 5px;
                color: #ffffff;
                text-align: left;
                display: inline;
              }
            }
          }
        }
      }

      .head-info:last-child {
        margin-bottom: 0;
        border-bottom: none;
        padding-bottom: 0;
      }
    }
  }
}
</style>
